import React from 'react';

const cars = [
  {
    id: 1,
    image: '/images/ourfleet/8.jpg',
    name: 'Swift Dzire',
    seats: '4 Seats',
    luggage: '2 Bags',
    ac: 'A/C Available',
    price: '₹12/km',
    link: '/our-fleet',
  },
  {
    id: 2,
    image: '/images/ourfleet/4.jpg',
    name: 'Ertiga',
    seats: '6-7 Seats',
    luggage: '4 Bags',
    ac: 'A/C Available',
    price: '₹15/km',
    link: '/our-fleet',
  },
  {
    id: 3,
    image: '/images/ourfleet/9.jpg',
    name: 'Tempo Traveller',
    seats: '12-17 Seats',
    luggage: '6+ Bags',
    ac: 'A/C Available',
    price: '₹25/km',
    link: '/our-fleet',
  },
];

const CarFleet = () => {
  return (
    <section className="vs-tour-package space py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-auto mx-auto">
            <div className="title-area text-center">
              <span className="sec-subtitle fade-anim" data-direction="bottom">
                Explore Our Fleet
              </span>
              <h2 className="sec-title fade-anim text-white" data-direction="top">
                Available Car Rentals
              </h2>
            </div>
          </div>
        </div>

        <div className="row g-4">
          {cars.map((car) => (
            <div key={car.id} className="col-md-6 col-xl-4 move-anim">
              <div className="tour-package-box style-2 bg-white-color">
                <div className="tour-package-thumb borderr">
                  <img src={car.image} alt={car.name} className="w-100" />
                </div>
                <div className="tour-package-content borderr">
                  <h5 className="title line-clamp-2">
                    <a href={car.link}>{car.name}</a>
                  </h5>
                  <div className="tour-package-meta">
                    <ul className="custom-ul">
                      <li>
                        <i className="fa-solid fa-user-group darkcolo"></i>
                        <span>{car.seats}</span>
                      </li>
                      <li> 
                        <i className="fa-solid fa-suitcase-rolling darkcolo"></i>
                        <span>{car.luggage}</span>
                      </li>
                      <li>
                        <i className="fa-solid fa-snowflake darkcolo"></i>
                        <span>{car.ac}</span>
                      </li>
                    </ul>
                  </div>
                  <div className="tour-package-footer">
                    <div className="pricing-info fw-medium">
                      Starting at <h5 className="new-price">{car.price}</h5>
                    </div>
                    <a href={car.link} className="buy-package">
                    <i className="fa-solid fa-arrow-right"></i>

                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CarFleet;
